/**
 * StyleX styles for the SignInCard component and subcomponents.
 */

import * as stylex from "@stylexjs/stylex";

import {
  colors,
  fontSize,
  radius,
  space,
} from "@animus/primaris/tokens.stylex";

const spin = stylex.keyframes({
  from: { transform: "rotate(0deg)" },
  to: { transform: "rotate(360deg)" },
});

export const card = stylex.create({
  container: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: colors.transparent,
  },
  card: {
    width: "100%",
    maxWidth: 448,
    borderRadius: radius.lg,
    backgroundColor: colors.card,
    padding: space["2xl"],
  },
});

export const header = stylex.create({
  wrapper: {
    marginBottom: space.xl,
  },
  title: {
    marginBottom: space.sm,
    textAlign: "center",
    fontWeight: 700,
    fontSize: fontSize["2xl"],
    color: colors.foreground,
  },
  subtitle: {
    textAlign: "center",
    color: colors.foregroundMuted,
  },
});

export const error = stylex.create({
  container: {
    marginBottom: space.lg,
    borderRadius: radius.md,
    backgroundColor: "rgba(239, 68, 68, 0.1)",
    padding: space.md,
    fontSize: fontSize.sm,
    color: colors.destructive,
  },
});

export const content = stylex.create({
  container: {
    display: "flex",
    flexDirection: "column",
    gap: space.lg,
  },
});

export const footer = stylex.create({
  container: {
    marginTop: space.xl,
    textAlign: "center",
    fontSize: fontSize.sm,
    color: colors.foregroundSubtle,
  },
});

export const loading = stylex.create({
  container: {
    textAlign: "center",
  },
  message: {
    marginBottom: space.lg,
    color: colors.foregroundMuted,
  },
  spinner: {
    marginLeft: "auto",
    marginRight: "auto",
    height: 32,
    width: 32,
    borderRadius: radius.full,
    borderWidth: 2,
    borderStyle: "solid",
    borderColor: colors.primary,
    borderTopColor: colors.transparent,
    animationName: spin,
    animationDuration: "1s",
    animationTimingFunction: "linear",
    animationIterationCount: "infinite",
  },
});

export const success = stylex.create({
  container: {
    textAlign: "center",
    color: colors.success,
  },
});
